import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Layout, Result } from 'antd';
import messages from './messages';

const { Content } = Layout;

const NoMatch = () => (
  <Content style={{ justifyContent: 'center' }}>
    <Result title={<FormattedMessage {...messages.header} />} subTitle={<FormattedMessage {...messages.content} />} />
  </Content>
);

export default NoMatch;
